<template>
  <div>
    <a-descriptions title="配置信息" :column="2">
      <a-descriptions-item label="模组厂商">
        {{ data.module_producer_name }}
      </a-descriptions-item>

      <a-descriptions-item label="模组型号">
        {{ data.module_model_name }}
      </a-descriptions-item>

      <a-descriptions-item label="供应商">
        {{ data.module_supplier_name }}
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
export default {
  name: 'AgentPurchaseItemModuleConfigureInfo',
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>
